import './bookDemo.scss';
import React from 'react';
import { App } from './app';
import ReactDOM from 'react-dom';
import { lang } from '@umu/ukit-lang';
import 'common/src/styles/common.scss';
import { langOptions } from '../../common/const';
import { bizServices } from 'businessCommon';
import { getAppData } from './service/bookDemo';
import { initHeader } from '@umu/umu-common-header';
import { IContractSales } from './interface/pageData';
import 'businessCommon/src/styles/businessCommon.scss';
import { getMenuData } from '../../plan/@planPricing/service/getMenuData';
import { render as headerRenderer, IHeaderConfig } from '@umu/home-header';
import { render as footerRenderer, IFooterConfig } from '@umu/home-footer';
import CommercializePage from 'src/common/page';

const { getPlatform } = bizServices;

class BookDemo extends CommercializePage<IContractSales> {
    constructor() {
        super(getAppData());
        this.setupPageTitle(this.getPageTitle());
        this.render();
    }
    public getInitState() {
        const state = {
            pageData: {
                contextInfo: getAppData('contextInfo'),
                userInfo: getAppData('userInfo') || {},
                referUrl: getAppData('refer_url'),
            },
        };
        return state;
    }

    public async render() {
        const store = this.getInitState();
        const pageData = store.pageData;
        const userInfo = pageData.userInfo;
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');

        if (userInfo.umu_id && +userInfo.umu_id > 0) {
            initHeader({
                userInfo: pageData.userInfo as any,
                siteHost: siteHost,
                lang: LANG,
                system: SYSTEM,
            });
        } else {
            const config = {
                siteHost: siteHost,
                platform: 'twww',
                system: SYSTEM.toLocaleUpperCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                headerData: (await getMenuData()).header,
                langOptions,
            };
            headerRenderer(config as IHeaderConfig, document.querySelector('#common-header') as HTMLElement);
        }

        footerRenderer(
            {
                siteHost,
                platform: 'twww',
                system: SYSTEM.toLowerCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                langOptions,
                footerData: (await getMenuData()).footer,
            } as IFooterConfig,
            document.querySelector('#common-footer') as HTMLElement,
        );

        ReactDOM.render(
            <div>
                <App referUrl={pageData.referUrl}></App>
            </div>,
            document.querySelector('.doc-wide'),
        );
    }
    private getPageTitle() {
        const platform = getPlatform();
        if (platform === 'mobile') {
            return lang('预约演示');
        }
        return lang('UMU 互动学习平台');
    }
}
export default new BookDemo();
